import React from 'react';
import PrintLayout from './PrintLayout';

const SoundBiteIcon = () => (
  <svg viewBox="0 0 16 16" width="13" height="13" style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 5, flexShrink: 0 }}>
    <circle cx="8" cy="8" r="7" fill="#5f7942"/>
    <rect x="7" y="4" width="2" height="5" rx="1" fill="white"/>
    <circle cx="8" cy="11.5" r="1" fill="white"/>
  </svg>
);

const CautionIcon = () => (
  <svg viewBox="0 0 16 16" width="13" height="13" style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 5, flexShrink: 0 }}>
    <polygon points="8,1 15,14 1,14" fill="#922b3f"/>
    <rect x="7" y="5.5" width="2" height="4" rx="1" fill="white"/>
    <circle cx="8" cy="12" r="1" fill="white"/>
  </svg>
);

export default function PrintQuotes({ pageNumber, reportData, meeting }) {
  const productive = reportData.quotes?.productive || [];
  const unproductive = reportData.quotes?.unproductive || [];
  const selected = meeting.selectedQuotes || {};
  const hasSelections = Object.keys(selected).length > 0;

  const soundBites = hasSelections
    ? productive.filter((_, i) => selected[`prod-${i}`])
    : productive;
  const cautionFlags = hasSelections
    ? unproductive.filter((_, i) => selected[`unprod-${i}`])
    : unproductive;

  const QBlock = ({ title, color, quotes, Icon }) => (
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: 10, fontWeight: 800, color, marginBottom: 10, letterSpacing: '0.5px', fontFamily: 'Montserrat, sans-serif', display: 'flex', alignItems: 'center' }}>
        <Icon />{title}
      </div>
      {quotes.length === 0
        ? <div style={{ fontSize: 9, color: '#6b757e', fontStyle: 'italic' }}>None selected</div>
        : quotes.slice(0, 6).map((q, i) => (
          <div key={i} style={{
            marginBottom: 8, padding: '8px 12px', background: 'white',
            borderRadius: 6, borderLeft: `3px solid ${color}`,
            fontSize: 9, color: '#2a3d5b', lineHeight: 1.5,
          }}>
            <div style={{ fontStyle: 'italic' }}>"{q.text?.slice(0, 120)}{q.text?.length > 120 ? '…' : ''}"</div>
            <div style={{ marginTop: 4, fontSize: 8, color: '#6b757e', fontWeight: 600 }}>
              {q.speaker?.split('@')[0]}
            </div>
          </div>
        ))
      }
    </div>
  );

  const hasCautionFlags = cautionFlags.length > 0;
  const title = hasCautionFlags ? 'Sound Bites & Caution Flags' : 'Sound Bites';

  return (
    <PrintLayout pageNumber={pageNumber}>
      <div style={{ position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, padding: '5% 6%', background: '#f5f4f0' }}>
        <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 24, fontWeight: 700, color: '#1e2e45', marginBottom: 20 }}>
          {title}
        </div>
        <div style={{ display: 'flex', gap: 24, height: 'calc(100% - 70px)' }}>
          <QBlock title="Sound Bites" color="#5f7942" quotes={soundBites} Icon={SoundBiteIcon} />
          {hasCautionFlags && <QBlock title="Caution Flags" color="#922b3f" quotes={cautionFlags} Icon={CautionIcon} />}
        </div>
      </div>
    </PrintLayout>
  );
}
